import { type JSX, ReactNode, useState } from "react";

import { IsFastConfigurationContext } from "./IsFastConfigurationContext";

export function IsFastConfigurationContextProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const [isFastConfiguration, setIsFastConfiguration] = useState(false);
  const value = { isFastConfiguration, setIsFastConfiguration };

  return (
    <IsFastConfigurationContext.Provider value={value}>
      {children}
    </IsFastConfigurationContext.Provider>
  );
}
